// src/components/auth/AIConfirmationDialog.tsx
import React from 'react';

interface AIConfirmationDialogProps {
    aiStatus: {
        configured: boolean;
        provider?: string;
        model?: string;
        ready: boolean;
    };
    onProceed: () => void;
    onConfigure: () => void;
}

const AIConfirmationDialog: React.FC<AIConfirmationDialogProps> = ({
    aiStatus,
    onProceed,
    onConfigure
}) => {
    return (
        <div className="login-popup-overlay">
            <div className="login-popup">
                <div className="popup-header">
                    <h4>AI Configuration Found</h4>
                </div>
                <div className="popup-content">
                    <p><strong>Provider:</strong> {aiStatus.provider || 'Unknown'}</p>
                    <p><strong>Model:</strong> {aiStatus.model || 'Unknown'}</p>
                    
                    <div className="popup-buttons">
                        <button
                            className="pushable push-primary btn-sm"
                            onClick={onProceed}
                        >
                            <span className="shadow"></span>
                            <span className="edge"></span>
                            <span className="front">Proceed with {aiStatus.provider}</span>
                        </button>
                        <button
                            className="pushable push-secondary btn-sm"
                            onClick={onConfigure}
                        >
                            <span className="shadow"></span>
                            <span className="edge"></span>
                            <span className="front">Change Configuration</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AIConfirmationDialog;